<template>
  <LegalPage
    title="Disclaimer"
    subtitle="Information and risk notice"
    intro="The content on gbmodshub.net is published for general information only. It is not legal, technical, or security advice."
    :sections="sections"
    email="contact@gbmodshub.net"
    page-name="disclaimer"
  />
</template>

<script>
import LegalPage from '@/components/LegalPage.vue';

export default {
  name: 'Disclaimer',
  components: {
    LegalPage,
  },
  data() {
    return {
      sections: [
        {
          heading: 'Independent Information Resource',
          paragraphs: [
            'gbmodshub.net is not the developer of GB WhatsApp, is not operated by WhatsApp Inc., and is not affiliated with Meta or any WhatsApp owner.',
            'A product name or download link on this site does not mean that we created, publish, host, or officially support that product.',
          ],
        },
        {
          heading: 'Trademarks and Names',
          paragraphs: [
            'WhatsApp and related names are trademarks of their respective owners. GB WhatsApp is an unofficial third-party modification of the official app.',
            'Names are used here for identification and explanation only. Their appearance does not suggest endorsement or partnership by the trademark owner.',
          ],
        },
        {
          heading: 'APK and Installation Risks',
          paragraphs: [
            'APK files can be changed by outside parties. Installing a modified messaging app may create security, device, or account-related risks.',
          ],
          items: [
            'Download APKs only when you understand the source and accept the risk.',
            'Keep a current local backup before switching or updating apps.',
            'Check the permissions requested during installation.',
            'Understand that modified apps may not receive official security updates.',
          ],
        },
        {
          heading: 'Accuracy and Link Availability',
          paragraphs: [
            'We try to keep version details and guides current, but app features, links, and file availability may change without notice. We do not guarantee that every link will stay online or work on every device.',
          ],
        },
        {
          heading: 'Limitation of Liability',
          paragraphs: [
            'To the fullest extent allowed by law, gbmodshub.net is not responsible for data loss, device problems, account restrictions, or other outcomes related to using this site, linked APK files, or third-party applications.',
          ],
        },
      ],
    };
  },
};
</script>
